import { useContext, useMemo } from 'react';

import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next';

import { useSessionData } from '@confluence/session-data';
import {
	createFabricMentionResource,
	useIsEligibleXProductUserInvite,
} from '@confluence/fabric-media-support';
import { CoreInvitesContext } from '@confluence/core-invites-provider';

import { useSpaceIdPromise } from './useSpaceIdPromise';

export function useMentionProvider(
	spaceId: string | null | undefined,
	withAnalyticsEventProps?: WithAnalyticsEventsProps,
	focusedMentionId?: string,
) {
	const { cloudId, userId } = useSessionData();
	const { openCoreInvites, userRole } = useContext(CoreInvitesContext);
	const isEligibleXProductUserInvite = useIsEligibleXProductUserInvite(); // check if user is eligible for XProductUserInvite

	const spaceIdPromise = useSpaceIdPromise(spaceId);

	return useMemo(
		() =>
			spaceIdPromise.then((spaceId) => {
				return createFabricMentionResource(
					cloudId,
					spaceId,
					userId,
					withAnalyticsEventProps,
					openCoreInvites,
					userRole,
					focusedMentionId,
					isEligibleXProductUserInvite,
				);
			}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			cloudId,
			userId,
			withAnalyticsEventProps,
			openCoreInvites,
			userRole,
			isEligibleXProductUserInvite,
		],
	);
}
